(ns com.theplantscape.web-ui.tailwind.colour-picker)

(defn colour-picker-cell [colour fn-callback]
  [:div.w-8.h-8.m-1.rounded-md
   {:on-click #(fn-callback colour)
    :style {:background-color colour}} "#"])

(defn colour-picker-row [row selection]
  (->> row
       (map #(colour-picker-cell % selection))
       (into [:div.flex.flex-row])))


(defn colour-picker [fn-callback]
  (let [range1 ["33" "66" "99" "CC" "FF" "FF" "FF" "FF" "FF" #_"FF"]
        range2 ["00" "00" "00" "00" "00" "33" "66" "99" "CC" #_"FF"]
        range3 (cycle ["22" "33" "44" "55" "66" "77" "88" "99" "aa" "bb" "cc" "dd" "ee" "ff"])]
    [:div.-top-4.bg-white {:style {:top "-80px"}}
     (->> [(map (fn [a b] (str "#" a b b))  range1 range2) ; red
           (map (fn [a b] (str "#" b a b))  range1 range2) ; green
           (map (fn [a b] (str "#" b b a))  range1 range2) ; blue
           (map (fn [a b] (str "#" a b a))  range1 range2) ; pink
           (map (fn [a b] (str "#" a a b))  range1 range2) ; yellow 
           (map (fn [a b] (str "#" b a a))  range1 range2) ; light blue
           (map (fn [a b] (str "#" a b "00")) (take 9 (drop 2 range3)) (take 9 range3))
           (map (fn [a b] (str "#" "00" a b)) (take 9 (drop 2 range3)) (take 9 range3))
           (map (fn [a b] (str "#"  a "00" b)) (take 9 (drop 2 range3)) (take 9 range3))
           ]
          (map #(colour-picker-row % fn-callback))
          (into [:div.flex.flex-col]))]))
